(() => {
  'use strict';
  if (customElements.get('sn75-pack-comparison')) return;

  class Sn75PackComparison extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.queued = false;
      try { this.data = JSON.parse(this.querySelector('[data-sn75-pack-data]')?.textContent || '{}'); }
      catch { this.hidden = true; return; }
      this.isCard = this.dataset.context === 'card';
      this.host = this.closest(this.isCard ? '[data-sn17-card]' : '[data-sn17-product]');
      this.separate = this.querySelector('[data-sn75-separate]');
      this.saving = this.querySelector('[data-sn75-saving]');
      if (!this.host || !this.separate || !this.saving || !this.data.variants) {
        this.hidden = true;
        return;
      }
      const currency = /^[A-Z]{3}$/.test(this.data.currency || '') ? this.data.currency : 'EUR';
      try { this.formatter = new Intl.NumberFormat(this.data.locale || 'fr-FR', { style: 'currency', currency }); }
      catch { this.formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency }); }
      const update = event => {
        if (event.target !== this.host) return;
        this.eventVariant = event.detail?.variant?.id;
        this.schedule();
      };
      for (const name of ['sn17:variant-change', 'sn17:purchase-change', 'sn17:card-variant-change']) {
        this.host.addEventListener(name, update, { signal: this.abort.signal });
      }
      const updateField = event => {
        if (event.target.matches('[data-sn17-quantity], [data-sn17-variant-id]')) this.schedule();
      };
      this.host.addEventListener('input', updateField, { signal: this.abort.signal });
      this.host.addEventListener('change', updateField, { signal: this.abort.signal });
      this.schedule();
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    schedule() {
      if (this.queued) return;
      this.queued = true;
      queueMicrotask(() => {
        this.queued = false;
        if (this.isConnected) this.refresh();
      });
    }

    refresh() {
      const variantInput = this.isCard ? null : this.host.querySelector('[data-sn17-variant-id]');
      const variantId = this.isCard
        ? this.host.dataset.variant || this.eventVariant || this.dataset.initialVariant
        : variantInput?.value || this.eventVariant || this.dataset.initialVariant;
      const quantityInput = this.isCard ? null : this.host.querySelector('[data-sn17-quantity]');
      const quantity = this.isCard ? 1 : Number(quantityInput?.value ?? 1);
      const entry = this.data.variants[String(variantId)];
      const validQuantity = Number.isSafeInteger(quantity) && quantity > 0 && quantityInput?.validity?.valid !== false;
      const validEntry = entry?.valid === true && Number.isSafeInteger(entry.separate) && Number.isSafeInteger(entry.price) && entry.price >= 0;
      const total = validEntry && validQuantity ? entry.separate * quantity : 0;
      const saving = validEntry && validQuantity ? (entry.separate - entry.price) * quantity : 0;
      this.hidden = !validEntry || !validQuantity || !Number.isSafeInteger(total) || !Number.isSafeInteger(saving) || saving <= 0;
      if (this.hidden) return;
      this.separate.textContent = this.formatter.format(total / 100);
      this.saving.textContent = String(this.data.save || '').replaceAll('[amount]', this.formatter.format(saving / 100));
    }
  }

  customElements.define('sn75-pack-comparison', Sn75PackComparison);
})();
